// IMPORTS


// COMPONENT
export function OHSCookiesGet (key) {
   const cookies = document.cookie.split('; ');
   for (const cookie of cookies) {
      const [name, value] = cookie.split('=');
      if (String(name) === String(key)) {
         return value;
      }
   }
   return null;
}
export function OHSCookiesSet (key, value) {
   document.cookie = key + "=" + value + "; path=/;";
}
export function OHSCookiesRemove (key) {
   document.cookie = key + "=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
}